import { useState } from "react";
import { useLanding } from "@/context/LandingContext";
import { InteractiveSection, MotionBg } from "./MotionBg";
import { Reveal } from "./Reveal";

export function ClaritySection() {
  const { t, setQuestionId } = useLanding();
  const [active, setActive] = useState(0);
  const pick = (index) => {
    setActive(index);
    setQuestionId(t.clarity.maps[index].question);
  };

  return (
    <InteractiveSection className="section section-dark clarity-section" data-testid="clarity-section">
      <MotionBg variant="rings" dots={3} />
      <div className="container clarity-layout">
        <Reveal className="clarity-copy">
          <p className="eyebrow"><span className="eyebrow-no">01</span>{t.clarity.eyebrow}</p>
          <h2>{t.clarity.title}</h2>
          <p className="lead">{t.clarity.lead}</p>
          <a className="btn btn-gold" href="#register" data-testid="clarity-cta">
            {t.clarity.button} <span className="arrow">→</span>
          </a>
        </Reveal>
        <Reveal className="clarity-map" tilt delay={0.1} aria-label="Interactive legacy clarity map">
          <div className="map-top">
            <div>
              <p className="map-kicker">{t.clarity.mapKicker}</p>
              <h2>{t.clarity.mapTitle}</h2>
            </div>
            <span className="map-status">{t.clarity.interactive}</span>
          </div>
          <div className="map-canvas">
            <div className="map-line" aria-hidden="true" />
            {t.clarity.maps.map((node, index) => (
              <button key={node.title} type="button" className={`map-node ${active === index ? "active" : ""}`} aria-pressed={active === index} onClick={() => pick(index)} data-testid={`map-node-${index}`}>
                <span className="node-no">0{index + 1}</span>
                <span className="node-copy">
                  <strong>{node.title}</strong>
                  <small>{node.meta}</small>
                </span>
              </button>
            ))}
          </div>
          <p className="map-message" aria-live="polite" data-testid="map-message">{t.clarity.maps[active].message}</p>
        </Reveal>
      </div>
    </InteractiveSection>
  );
}
